// src/api/transactions.js
import axiosInstance from './axiosInstance';
import Transactions from "../../network/models/transactions";
import axios from 'axios';


// Fetch transactions from the server
export const fetchTransactions = async () => {
    try {
        const response = await axiosInstance.get('/getTransactions'); // Use relative path
        if (response.data.success) {
            const items = response.data.data.map((item) => new Transactions(item));
            return items; // Return the items instead of setting state here
        } else {
            throw new Error("Failed to fetch transactions");
        }
    } catch (error) {
        throw error; // Rethrow the error to handle it in the calling function
    }
};

// export const getBaseUrl = as
export const addInventory = async (inventoryData) => {
    try {
        const response = await axiosInstance.post('/addInventory', inventoryData);
        if (response.data.success) {
            return response.data.data; // Return the added inventory data
        } else {
            throw new Error(response.data.message); // Throw error if not successful
        }
    } catch (error) {
        throw error; // Rethrow error for handling in the component
    }
}


export const addBill = async (billingData) =>{
    try {
        const response = await axiosInstance.post('/doBilling', billingData);
        if (response.data.success) {
            return response.data; // Return the added bill data
        } else {
            throw new Error(response.data.message); // Throw error if not successful
        }
    } catch (error) {
        throw error; // Rethrow error for handling in the component
    }
}
export const createNewRetailer = async (retailerDetails) => {
    try {
        const response = await axiosInstance.post('/createUser', retailerDetails);

        // Check if the response indicates success
        if (response.data.success) {
            return response.data.data; // Return the added retailer data
        } else {
            // If the response is not successful, throw an error with the message from the response
            throw new Error(response.data.message || 'Failed to create retailer'); // Fallback message if none is provided
        }
    } catch (error) {
        // Check if error is from Axios and extract the response message
        if (axios.isAxiosError(error) && error.response) {
            // Log the full error response for debugging purposes
            console.error('Axios error:', error.response);
            throw new Error(error.response.data.message || 'An error occurred while creating the retailer.'); // Use the error message from the response if available
        } else {
            // Rethrow the original error if it's not an Axios error
            throw new Error(error.message || 'An unexpected error occurred.');
        }
    }
}

export const createNewDepartment = async (details) => {
    try {
        const response = await axiosInstance.post('/createDepartments', details);
        if (response.data.success) {
            return response.data.data;
        } else {
            throw new Error(response.data.message);
        }
    } catch (error) {
        throw error;
    }
}